import React from "react";
import { getDrupalImageUrl } from "../../api/about/aboutapi";
import { CMS_API_BASE } from "../../helper/constants";
import CountUp from "react-countup";

interface Props {
  data: any;
}

const StatsSectionn: React.FC<Props> = ({ data }) => {
    const node = data.data;
      
         /** Collect included images */
        const included = data?.included || [];
      
         // 📌 Featured image URL
        const featuredId = node?.relationships?.field_featured_image?.data?.id;
        const featuredUrl = getDrupalImageUrl(featuredId, included);
      
         // 📌 Gallery Images
         const galleryIds = node?.relationships?.field_gallery_images?.data || [];
         const galleryImages = galleryIds.map((img:any) => {
          const media = included.find((inc:any) => inc.id === img.id);
          const file = included.find(
            (inc:any) => inc.id === media?.relationships?.field_media_image?.data.id
          );
  
          return file?.attributes?.uri?.url || "";
        });
        //  const galleryUrls = galleryIds
        //    .map((g: any) => getDrupalImageUrl(g.id, included))
        //    .filter(Boolean);
       
          const titles = node.attributes.field_title;            // array
          const descriptions = node.attributes.field_sub_description; // array
          const subtitles = node.attributes.field_sub_title; // array
  
          const finalArray = titles.map((title:any, index:any) => ({
            title,
            subtitle: subtitles[index],
            description: descriptions[index],
            image: CMS_API_BASE+galleryImages[index]
          }));
  return (
    <section className="stats dark-background bg-blue stats-about pt-5 pb-5">
      <div className="container">
        <div className="row gx-2">
          <div className="offset-sm-1 col-sm-10">
            <div className="row gy-4">
              {finalArray.map((d:any,i:any) => (
                <div  key={i}  className={`col-lg-4 col-md-4 col-sm-6  d-flex flex-column align-items-center `}>
                  <img  loading="lazy"  src={d.image}  className="img-fluid px-3"  />

                  <div className="stats-item">
                     <CountUp start={0} end={parseInt(d.title) || 0}  duration={3} /> +
                    
                    <p>
                      {d.subtitle}
                      <br />
                      {d.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsSectionn;